// ======================================
// 🔥 BACKTESTX UNIVERSAL RESOLVE SYMBOL
// Supports: Stocks, Crypto, Forex, Indices, Metals
// ======================================
export const resolveSymbol = (
  symbolName,
  onSymbolResolvedCallback,
  onResolveErrorCallback,
  extension
) => {

  const tokenSymbol = symbolName || "AAPL";

  if (!tokenSymbol) {
    setTimeout(() => onResolveErrorCallback("Symbol not found"), 0);
    return;
  }

  // Clean logic symbol (DO NOT change ticker)
  const logicSymbol = tokenSymbol.toUpperCase().replace("_REPLAY", "");

  // ===============================
  // 🔥 MASTER SYMBOL MAP (YOUR LIST)
  // ===============================
  const STOCKS = [
    "AAPL", "MSFT", "NVDA", "TSLA", "GOOGL", "AMZN", "META", "NFLX", "AMD", "JPM", "V",
    "RELIANCE", "HDFCBANK", "TCS", "INFY"
  ];

  const CRYPTO = [
    "BTC-USD", "ETH-USD", "SOL-USD", "BNB-USD", "XRP-USD",
    "ADA-USD", "DOGE-USD", "TRX-USD", "LINK-USD", "AVAX-USD"
  ];
  const FOREX = [
    "EUR-USD",
    "USD-JPY",
    "GBP-USD",
    "AUD-USD",
    "USD-CAD",
    "USD-CHF",
    "NZD-USD",

    // Cross Pairs
    "EUR-JPY",
    "GBP-JPY",
    "EUR-GBP",
    "EUR-AUD",
    "EUR-CAD",
    "EUR-CHF",
    "EUR-NZD",
    "GBP-AUD",
    "GBP-CAD",
    "GBP-CHF",
    "GBP-NZD",
    "AUD-JPY",
    "AUD-CAD",
    "AUD-CHF",
    "AUD-NZD",
    "CAD-JPY",
    "CAD-CHF",
    "CHF-JPY",
    "NZD-JPY",
    "NZD-CAD",
    "NZD-CHF",

    // Exotic USD Pairs (Good for premium datasets)
    "USD-INR",
    "USD-CNY",
    "USD-HKD",
    "USD-SGD",
    "USD-THB",
    "USD-KRW",
    "USD-ZAR",
    "USD-MXN",
    "USD-BRL",
    "USD-TRY",
    "USD-RUB",
    "USD-SEK",
    "USD-NOK",
    "USD-DKK",
    "USD-PLN",
    "USD-HUF",
    "USD-CZK",

    // Euro & GBP Exotics
    "EUR-SEK",
    "EUR-NOK",
    "EUR-DKK",
    "EUR-PLN",
    "EUR-HUF",
    "EUR-CZK",
    "GBP-SEK",
    "GBP-NOK",

    // Asia Liquidity Crosses
    "AUD-SGD",
    "AUD-HKD",
    "SGD-JPY",
    "HKD-JPY"
  ];

  const METALS = [
    "XAU-USD",
    "XAG-USD",
    "XAU-EUR",
    "XAU-GBP",
    "XPT-USD", // Platinum (your target)
    "XPD-USD"  // Palladium
  ];

  const INDICES = [
    "SPX", "NDX", "DJI", "VIX", "NIFTY", "BANKNIFTY", "DAX", "NIKKEI"
  ];

  // ===============================
  // 🔥 DETECT TYPE (PROFESSIONAL WAY)
  // ===============================
  let type = "stock";
  let session = "24x7";
  let exchange = "CUSTOM"; // ✅ Required in v31
  let pricescale = 100;

  if (CRYPTO.includes(logicSymbol)) {
    type = "crypto";
    session = "24x7";
    pricescale = 100; // crypto 2 decimals (can change to 1000 if needed)
  }
  else if (FOREX.includes(logicSymbol)) {
    type = "forex";
    // ✅ v31 fix: "24x5" removed, use explicit 24hr weekday session
    session = "0000-0000:23456";

    // JPY pairs need different scale
    if (logicSymbol.includes("JPY")) {
      pricescale = 1000;
    } else if (logicSymbol === "USD-INR") {
      pricescale = 10000;
    } else {
      pricescale = 100000;
    }
  }
  else if (METALS.includes(logicSymbol)) {
    type = "cfd"; // TradingView standard for gold/silver
    // ✅ v31 fix: "24x5" removed
    session = "0000-0000:23456";
    pricescale = 100;
  }
  else if (INDICES.includes(logicSymbol)) {
    type = "index";
    // ✅ v31 fix: "24x5" removed
    session = "0000-0000:23456";
    pricescale = 100;
  }
  else if (STOCKS.includes(logicSymbol)) {
    type = "stock";

    // Indian stocks vs US stocks session
    if (
      logicSymbol === "RELIANCE" ||
      logicSymbol === "HDFCBANK" ||
      logicSymbol === "TCS" ||
      logicSymbol === "INFY"
    ) {
      session = "0915-1530"; // NSE session (IST)
      pricescale = 100;
    } else {
      session = "0930-1600"; // US market session
      pricescale = 100;
    }
  }
  else {
    // Fallback (safe default)
    type = "crypto";
    session = "24x7";
    pricescale = 100;
  }

  const symbolInfo = {
    // 🚨 KEEP EXACT (VERY IMPORTANT FOR REPLAY ENGINE)
    ticker: tokenSymbol,
    name: tokenSymbol,
    description: `${logicSymbol} Backtestx Data`,

    type: type,
    session: session,
    exchange: exchange,          // ✅ Required in v31
    listed_exchange: exchange,   // ✅ Required in v31
    timezone: "Etc/UTC",

    minmov: 1,
    pricescale: pricescale,
    has_intraday: true,

    intraday_multipliers: ['1', '2', '3', '5', '10', '15', '30', '60', '120', '180', '240'],
    supported_resolutions: ['1', '2', '3', '5', '10', '15', '30', '60', '120', '180', '240', '1D'],

    has_empty_bars: false,
    has_weekly_and_monthly: true,
    volume_precision: 2,
    data_status: "streaming",
  };

  console.log(
    `🧠 resolveSymbol: ${tokenSymbol} | Type=${type} | Scale=${pricescale}`
  );

  setTimeout(() => {
    onSymbolResolvedCallback(symbolInfo);
  }, 0);
};
